<template>
  <el-collapse class="specs" v-model="activeCollapse">
    <el-collapse-item v-for="(item, index) in info" :key="index" :name="index">
      <template slot="title">
        <div class="specs-head flex flex-between">
          <div>{{ item.checkmallFirstRankName }}</div>
          <div class="specs-head-price"></div>
        </div>
      </template>
      <div class="specs-table">
        <div v-for="(item, index) in item.secondRank" :key="index">
          <label>项目名称：</label
          ><span>{{ item.checkmallSecondRankName }}</span>
          <label>周期(天)：</label><span>{{ item.serviceCycle }}</span>
          <label>计价(元)/单位：</label>
          <span v-if="item.face">面议</span>
          <span v-else-if="item.discountedPrice">
            {{ item.discountedPrice }}/{{ unitMap[+item.serviceUnitType] }}
          </span>
          <span
            v-if="item.discountStatus && item.discountStatus < 10"
            class="specs-dis"
          >
            {{ item.price }}/{{ unitMap[+item.serviceUnitType] }}
          </span>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
export default {
  name: "specs",

  props: {
    info: {
      type: Array,
      default: () => [],
    },
    unitMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeCollapse: 0,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.specs {
  ::v-deep .el-collapse-item__header,
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__content {
    padding-bottom: 5px;
  }
  label {
    color: #999;
  }
  span {
    margin-right: 10px;
  }
  &-dis {
    text-decoration: line-through;
    color: #b9b9b9;
  }
}
</style>
